export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              tagname: 'div',
              name: "Coluna Numeros",
              attributes: { class: 'column column-50 p-20' },
              components: [
                
                {
                  type: 'text',
                  content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam viverra ex mauris, sed semper elit fermentum at. Nunc mattis tellus at maximus lacinia. Pellentesque felis lorem, scelerisque at tristique non, consequat eget ligula. Ut varius vitae dolor vitae luctus. Sed porta purus metus, vitae semper odio fermentum sit amet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Donec faucibus nibh in justo ultrices ullamcorper.',
                  attributes: { class: 'body-text' },
                },
                {
                  type:'div',
                  attributes: { class: 'div-counters-5'}, 
                  components: [
                    {
                        type: 'counters5'
                    },
                    {
                        type: 'counters5'
                    },
                    {
                        type: 'counters5'
                    },
                  ]
                },
                {
                  type: 'button',
                },
              ],
              styles: `
              .div-counters-5{
                width: 120%; 
                position: relative; 
                left: -20%; 
                z-index:99; 
                margin-top:30px;
              }
              .body-text{
                font-size: 16px; 
                color: #95A1BB; 
              }
              @media (max-width: 992px){
                .div-counters-5{
                  width:100%; 
                  left: 0; 
                }
              }
            `,
            },
          },
          view: {
      
          },
};
  return component; 
};